export const queryKeyFactory = (rootKey: string) => ({
  all: [rootKey] as const,
  lists: [rootKey, 'list'] as const,
  list: (...args: any[]) => [rootKey, 'list', ...args] as const,
  details: [rootKey, 'detail'] as const,
  detail: (id: string | number, ...args: any[]) =>
    [rootKey, 'detail', id, ...args] as const,
});
